import { render, staticRenderFns } from "./ModalBackground.vue?vue&type=template&id=b4296cd8&scoped=true"
import script from "./ModalBackground.vue?vue&type=script&lang=js"
export * from "./ModalBackground.vue?vue&type=script&lang=js"
import style0 from "./ModalBackground.vue?vue&type=style&index=0&id=b4296cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4296cd8",
  null
  
)

export default component.exports